import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";
import { FilterValues } from "../../../data-model/filterValues";
import { useFilterAndSearchEffect } from "./useFilterAndSearchEffect";
import { PrimaryCareFilterPayload, useFilterPayload } from "./useFilterPayload";
import { usePaginationReset } from "./usePaginationReset";
import { PrimaryCareTableState } from "./usePrimaryCareTableData";
import { useSearchTerm } from "./useSearchTerm";
import { useValidFilters } from "./useValidFilters";

export interface UseFilterAndSearchReturn {
  filterPayload: PrimaryCareFilterPayload | null;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  paginationResetCount: number;
  validFilters: FilterValues[];
}

export const useFilterAndSearch = (
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<AestraPrimaryCareTable[]>>,
  setPrimaryCareState: React.Dispatch<
    React.SetStateAction<PrimaryCareTableState>
  >,
  dateFromStart: string,
  dateFromEnd: string,
  pageSize: number = 120,
): UseFilterAndSearchReturn => {
  const { searchTerm, setSearchTerm } = useSearchTerm();

  const { paginationResetCount, setPaginationResetCount } =
    usePaginationReset();

  const validFilters = useValidFilters();

  const { filterPayload } = useFilterPayload(
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
    dateFromStart,
    dateFromEnd,
    pageSize,
  );

  useFilterAndSearchEffect(
    filterPayload,
    initialDataFetchingExecuted,
    setTableData,
    setPrimaryCareState,
    setPaginationResetCount,
  );

  return {
    filterPayload,
    searchTerm,
    setSearchTerm,
    paginationResetCount,
    validFilters,
  };
};
